import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_BlfqP9QnDB75: {
	id: 'prd_BlfqP2DEV29QnDB75'
	ident: 'prd_BlfqP9QnDB75'
	sku: 'simple_premium_6m_39_99_6m_139_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'month'
			interval_duration: 6
			iteration_count: 1
			price_id: 'prc_s7C9j2DEV2zGpr0qm'
			amount: 139
			amount_usd: 39.99
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 39.99
			discount: 99.01
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'month'
			interval_duration: 6
			iteration_count: null
			price_id: 'prc_jLCvE2DEV2Is5E6rH'
			amount: 139
			amount_usd: 139
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_BlfqP9QnDB75, SubscriptionProduct>
const prd_BlfqP9QnDB75 = { ident: 'prd_BlfqP9QnDB75' } as typeof _prd_BlfqP9QnDB75

export default prd_BlfqP9QnDB75
